import React from "react";

import { Link } from "react-router-dom";

import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

import ButtonUI from "./ButtonUI";

const KMKNavigateButton = ({
  iconButton = false,
  disabled = false,
  navigationProps,
  tooltipProps = false,
  children,
  ...otherProps
}) => {
  return tooltipProps ? (
    <Tooltip
      title={tooltipProps.title}
      placement={tooltipProps.placement || "top"}
      arrow={tooltipProps.arrow || false}
      disableHoverListener={disabled}
      disableInteractive={disabled}
    >
      <Link onClick={(e) => e.stopPropagation()} {...navigationProps}>
        {iconButton ? (
          <IconButton disabled={disabled} {...otherProps}>
            {children}
          </IconButton>
        ) : (
          <ButtonUI disabled={disabled} {...otherProps}>
            {children}
          </ButtonUI>
        )}
      </Link>
    </Tooltip>
  ) : (
    <Link onClick={(e) => e.stopPropagation()} {...navigationProps}>
      {iconButton ? (
        <IconButton disabled={disabled} {...otherProps}>
          {children}
        </IconButton>
      ) : (
        <ButtonUI disabled={disabled} {...otherProps}>
          {children}
        </ButtonUI>
      )}
    </Link>
  );
};

export default KMKNavigateButton;
